import { conditionConditionSetApi, conditionSetApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CONDITION_SET_ACTION_TYPE = createNamedActions('conditionSets', {
  GET_CONDITION_SETS: 'GET_CONDITION_SETS',
  ADD_CONDITION_SET: 'ADD_CONDITION_SET',
  DELETE_CONDITION_SET: 'DELETE_CONDITION_SET',
  UPDATE_CONDITION_SET: 'UPDATE_CONDITION_SET',
  ADD_CONDITION_TO_SET: 'ADD_CONDITION_TO_SET',
  DELETE_CONDITION_FROM_SET: 'DELETE_CONDITION_FROM_SET',
});

const conditionSets = new schema.Entity('conditionSets', {}, { idAttribute: 'id' });

export const getConditionSetsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await conditionSetApi.getConditionSet();

  return dispatch({
    type: CONDITION_SET_ACTION_TYPE.GET_CONDITION_SETS,
    payload: normalize(data, [conditionSets]).entities.conditionSets,
  });
});

export const addConditionSetAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await conditionSetApi.createConditionSet(body);

  return dispatch({
    type: CONDITION_SET_ACTION_TYPE.ADD_CONDITION_SET,
    payload: data,
  });
});

export const editConditionSetAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await conditionSetApi.editConditionSet(params);

  return dispatch({
    type: CONDITION_SET_ACTION_TYPE.UPDATE_CONDITION_SET,
    payload: data,
  });
});

export const deleteConditionSetAction = catchAsyncActionError(params => async dispatch => {
  await conditionSetApi.deleteConditionSet(params);

  return dispatch({
    type: CONDITION_SET_ACTION_TYPE.DELETE_CONDITION_SET,
    payload: params.conditionSetId,
  });
});

export const addConditionToSetAction = catchAsyncActionError(
  ({ condition, ...body }) =>
    async dispatch => {
      const { data } = await conditionConditionSetApi.createConditionConditionSet(body);

      return dispatch({
        type: CONDITION_SET_ACTION_TYPE.ADD_CONDITION_TO_SET,
        payload: { ...data, condition },
      });
    },
);

export const deleteConditionFromSetAction = catchAsyncActionError(params => async dispatch => {
  const { conditionConditionSetId } = params;

  await conditionConditionSetApi.deleteConditionConditionSet({ conditionConditionSetId });

  return dispatch({
    type: CONDITION_SET_ACTION_TYPE.DELETE_CONDITION_FROM_SET,
    payload: params,
  });
});
